import {MEMBERSHIP_MYTRIPS_REACTIVATION} from 'od-modules/utils/membership_constants';

(function() {
    if (!Odigeo.AB.isMytripsloginOf2) {
        'use strict';
        const trackingUtils = require('../modules/utils/tracking.utils');
        const tagManagement = require('../modules/utils/tag_management.utils');
        const loginFactory = require('components/user_area/login/js/main');
        const myTripsLoginFactory = require('components/user_area/my_trips_login/js/main');
        const createWidgetLoader = require('components-framework/widget/create_widget_loader');
        const tripdetailsStorageUtils = require('../modules/utils/tripdetails_storage.utils');
        const PATH_PARAM_REGEX = new RegExp(/(?:\/|%2F)/gi);
        Odigeo.Router.handlers.mytripslogin = function(params) {
            const {actions} = Odigeo._.defaults({}, Odigeo.Utils.parseHashParameters(params, PATH_PARAM_REGEX));
            const hasRedirectToSA = actions === 'opensa';
            const widgetLoader = createWidgetLoader({
                login: ['my-trips-login-form', loginFactory],
                myTripsLogin: ['my-trips-login', myTripsLoginFactory, {hasRedirectToSA}],
            });
            const pageName = 'mytripslogin';
            const BOOKING_INFO = 'bookingInfo';
            const $page = $('#page');
            $page.removeClass().addClass(pageName);

            Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController,
                Odigeo.Router.handlers.globalEventController,
                Odigeo.Router.handlers.userEventController, {
                    // Global events will remain bound in any part of the application
                    globalEvents: {
                        'global:userLogged': 'onLoginMT',
                        'global:loginOk': 'onLoginMT',
                        'global:userNotLoggedRemembered': 'onLoginMT',
                        'global:loginWithError': 'onLoginEventsMT',
                        'global:loginError': 'onLoginEventsMT',
                        'global:recoverPasswordOk': 'onLoginEventsMT',
                        'global:recoverPasswordWithError': 'onLoginEventsMT',
                        'global:recoverPasswordError': 'onLoginEventsMT',
                    },
                    viewEvents: {
                        'my-trips-login-form:submitUserRequest': 'onSubmitUserRequestMT',
                        'my-trips-login-form:openRegister': 'onOpenRegisterMT',
                        'my-trips-login-form:userLoggedMT': 'onLoginMT',
                        'my-trips-login:openRegister': 'onOpenRegisterMT',
                        'my-trips-login:submitUserRequest': 'onSubmitUserRequestMT',
                        'users-manager:getTripWithError': 'onLoadEventError',
                        'users-manager:getTripError': 'onLoadEventError',
                        'users-manager:getTripOk': 'onLoadEvent',
                        'my-trips-login:loadTripOK': 'onLoadTripOK',
                        'recaptcha:loaded': 'onRecaptchaLoaded',
                    },
                    eventHandlers: {
                        onSubmitUserRequestMT: function(data) {
                            Odigeo.requireWidget('users-manager', 'usersmanager', function(usersmanager) {
                                usersmanager.execute('submitUserRequest', data);
                            });
                        },
                        onLoginMT: function({action}) {
                            if (hasRedirectToSA) {
                                Odigeo.Router.navigate('sahome');
                            } else {
                                Odigeo.Router.navigate(MEMBERSHIP_MYTRIPS_REACTIVATION);
                                if (action === 'loginOk') {
                                    Odigeo.Router.reload();
                                }
                            }
                        },
                        onOpenRegisterMT: function() {
                            if (Odigeo.History.getPageNameFromFragment() === 'register') {
                                widgetLoader.get('login').execute('closeConnectorsLayer');
                            } else {
                                Odigeo.Router.navigate('user-register');
                            }
                        },
                        onLoginEventsMT: function(data) {
                            widgetLoader.get('login').execute(data.action, data);
                        },
                        onLoadEvent: function(data) {
                            widgetLoader.get('myTripsLogin').execute(data.action, data);
                        },
                        onLoadEventError: function(data) {
                            widgetLoader.get('myTripsLogin').execute('getTripError', data);
                        },
                        onLoadTripOK: function({bookingDetailDTO}) {
                            tripdetailsStorageUtils.setInSessionWithExpirationTime(BOOKING_INFO, bookingDetailDTO);
                            if (hasRedirectToSA) {
                                Odigeo.Router.navigate(`sahome/${bookingDetailDTO.tdToken || ''}`);
                            } else {
                                Odigeo.Router.navigate('tripdetails');
                            }
                        },

                        onRecaptchaLoaded: function() {
                            widgetLoader.get('login').execute('renderCaptcha', true);
                        },
                    },
                });

            Odigeo.Router.eventController.execute();
            widgetLoader.get('myTripsLogin').execute('actionsHandler', actions);

            // Analytics: virtual page tracking
            trackingUtils.trackPage(pageName, {
                funnel: false,
            });
            tagManagement.updateDatalayer();
        };
    }
}());

